module.exports = __webpack_public_path__ + "img/eth-logo-switch-grey.115d5a42.svg";